// Libraries
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

// Api URls
import { SAMPLE_FILE_DOWNLOAD } from '../../utils/API/apiUrls';

// Constants
import { ERROR_MESSAGES } from '../../utils/constants/toastMessages';

// Assets
import DownloadIcon from '../../static/images/downloadIcon.png';

// Components
import { FormElems } from '../../components/';
import SearchBar from './SearchBar';

const filePlaceHolder = { name: 'Upload .CSV File' };

const BinHeader = props => {
    const { uploadFile, handleBtnClick } = props;
    const [selectedFile, setSelectedFile] = useState(filePlaceHolder);
    const history = useHistory();

    const handleFileChange = (value, event) => {
        event.preventDefault();
        const files = event.target.files[0];
        if (files && /.+(\.csv)$/.test(files.name)) {
            setSelectedFile(files);
            const formData = new FormData();
            formData.append('inputFile', event.target.files[0]);
            uploadFile(formData);
        } else {
            toast.info(ERROR_MESSAGES.ONLY_CSV_FILE);
        }
    };

    const downloadFile = () => {
        const link = document.createElement('a');
        link.href = SAMPLE_FILE_DOWNLOAD;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="bin-header">
            <h3 className="page-tile">Manage Bin</h3>
            <div className="bin-actions">
                <SearchBar />
                <ul className="download-actions">
                    {/* <li onClick={downloadFile}>
                        <img
                            src={DownloadIcon}
                            alt="Download"
                            className="download-icon"
                        />
                        <div className="action-text">
                            <p>Download Sample File</p>
                            <label>File will be download without data</label>
                        </div>
                    </li>
                    <li>
                        <label htmlFor="UploadBinFile" className="file-label">
                            <img
                                src={DownloadIcon}
                                alt="Download"
                                className="download-icon"
                            />
                            <div className="action-text">
                                <p>Upload File</p>
                                <label>{selectedFile.name || ''}</label>
                            </div>
                        </label>
                        <form encType="multipart/form-data" action="">
                            <FormElems.Input
                                name="uploadFile"
                                type="file"
                                id="UploadBinFile"
                                wrapperClass="fileInput"
                                defaultValue="fileName"
                                input="true"
                                handleChange={handleFileChange}
                            />
                        </form>
                    </li> */}
                    <li onClick={() => { history.push('/manage-bin/formatting'); }}>
                        <img
                            src={DownloadIcon}
                            alt="Download"
                            className="download-icon"
                        />
                        <div className="action-text">
                            <p>Network Specific BINs</p>
                            <label>Click here to upload Network specific Bin Files</label>
                        </div>
                    </li>


                </ul>
                <div className='update-bin-action'>
                    <button
                        className='updateBinBtn'
                        id="update-bin"
                        onClick={handleBtnClick}
                    >Update Bin</button>
                </div>
            </div>

        </div>
    );
};

BinHeader.propTypes = {
    tabList: PropTypes.array,
    selectedTab: PropTypes.string,
    setSelectedTab: PropTypes.func,
    uploadFile: PropTypes.func,
};

export default BinHeader;
